import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../Icon";
import { CounterButton, CounterContainer, CounterDisplay } from "./styles";
export function Counter({ disabled, hasMiminumQuantity, quantity = 0, maxWidth, width, loading, initialQuantity, onRemove, onAdd, onChange, onBlur, hasPermission, "data-testid": dataTestId, }) {
    const loadingAll = loading === "typing";
    const loadingIncrement = loading === "increment";
    const loadingDecrement = loading === "decrement";
    const handleChange = ({ currentTarget }) => {
        if (String(currentTarget.value).length <= 6) {
            onChange?.(String(currentTarget?.value).getOnlyNumber() ?? "");
        }
    };
    const handleBlur = ({ currentTarget }) => {
        const currentValue = currentTarget.value;
        if (!currentValue)
            onChange?.(Number(initialQuantity) || 0);
        onBlur?.(!currentValue && !initialQuantity ? 0 : currentValue);
    };
    const preventNotNumbers = (e) => {
        const keysAvailable = Array.from({ length: 10 }, (_, i) => String(i));
        if (!keysAvailable.includes(e.key)) {
            e.preventDefault();
        }
    };
    return (_jsxs(CounterContainer, { "data-testid": dataTestId || "counter", maxWidth: maxWidth, width: width, disabled: disabled, hasPermission: hasPermission, children: [_jsx(CounterButton, { loading: loadingAll || loadingDecrement, disabled: hasMiminumQuantity !== undefined ? hasMiminumQuantity : loadingIncrement, onClick: disabled ? undefined : onRemove, variant: "none", "data-testid": "remove", loadingProps: {
                    size: "16",
                }, hasPermission: hasPermission, children: _jsx(Icon, { color: "--text-primary", size: "20px", name: "do_not_disturb_on", fill: true }) }), _jsx(CounterDisplay, { type: "tel", maxLength: 5, "data-testid": "display", onBlur: handleBlur, onChange: handleChange, onKeyPress: preventNotNumbers, onPaste: (e) => e.preventDefault(), value: String(quantity).getOnlyNumber() ?? "", disabled: !hasPermission || disabled }), _jsx(CounterButton, { loading: loadingAll || loadingIncrement, disabled: loadingDecrement || Number(quantity) >= 999999, onClick: disabled ? undefined : onAdd, variant: "none", "data-testid": "add", loadingProps: {
                    size: "16",
                }, hasPermission: hasPermission, children: _jsx(Icon, { color: "--text-primary", size: "20px", name: "add_circle", fill: true }) })] }));
}
//# sourceMappingURL=index.js.map